module.exports = __webpack_public_path__ + "static/media/cv.3add9d92.jpg";